import type { UploadFileResponse } from './Types';
import { request } from '@/utils/Request';

/**
 * 上传文件
 * @param formData 包含文件的FormData对象
 * @returns 上传结果
 */
export const uploadFile = (formData: FormData) => {
  return request.post<UploadFileResponse>('/api/file/upload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};
